// extracted by mini-css-extract-plugin
export default {"container":"modal_container__eBW+u","title":"modal_title__6BaA+","close-button":"modal_close-button__mBv0X"};